angular.module('backstage.directives.tables', [])
    .directive('bsDynamicExtensionValueDisplayCell', require('./bsDynamicExtensionValueDisplayCell'))
    .directive('bsAssetFilePreviewCell', require('./bsAssetFilePreviewCell'))
    .directive('bsNavigateToPaxProfileCell', require('./bsNavigateToPaxProfileCell'))
    .directive('bsNavigateToViewGenericItem', require('./bsNavigateToViewGenericItem'))
    .directive('bsTableCellTick', require('./bsTableCellTick'))
    .directive('bsTableItemSelectionActions', require('./bsTableItemSelectionActions'));
